export default __webpack_public_path__ + "static/media/p7.66002d80.png";